<template>
  <div>
    <b-table
      id="user-table"
      class="rounded mt-2 px-1 bg-light-secondary"
      :tbody-tr-class="['tableRowClass']"
      small
      :fields="fields"
      :items="GET_MATERIALS_FOR_BUILDERS.results"
      show-empty
      responsive
      :empty-text="$t('empty_text')"
    >
      <template #head()="props">
        <span>{{ $t(props.label) }}</span>
      </template>
      
      <template #cell(category)="{ item }">
        <span v-if="item.product.category && item.product.category.title">
          {{ item.product.category.title }}
        </span>
      </template>

      <template #cell(total_count)="{ item }">
        <span v-if="item && item.total_count">
          {{ $_formatPriceMixin(item.total_count) }}
        </span>
      </template>

      <template #cell(actions)="props">
        <div class="d-flex align-items-center">
          <b-button
            :disabled="props.item.is_pto_write_off_disabled"
            v-if="checkButtonPermission(['builder'])"
            @click="addPto(props.item)"
            size="sm"
            variant="primary"
            class="d-block ml-50"
          >
            {{$t('write_off_pto')}}
          </b-button>
          <b-button
            v-if="checkButtonPermission(['builder'])"
            @click="returnItems(props.item)"
            size="sm"
            variant="warning"
            class="d-block ml-50"
          >
            {{$t('return')}}
          </b-button>
        </div>
      </template>
    </b-table>

    <addPtoModal :item="item" @reload="FETCH_MATERIAL_FOR_BUILDERS" />

    <returnModal :item="data_item" @reload="FETCH_MATERIAL_FOR_BUILDERS" />
  </div>
</template>

<script>
import { BButton, BTable, BCard } from "bootstrap-vue";
import { mapGetters, mapActions } from "vuex";
import addPtoModal from "../addPto2Modal.vue";
import returnModal from "../returnModal.vue";

import check from "@/mixins/check";
import priceFormatMixin from "@/mixins/priceFormatMixin";

export default {
  components: {
    BTable,
    BButton,
    BCard,
    addPtoModal,
    returnModal,
  },
  mixins: [priceFormatMixin, check],
  data: () => ({
    item: null,
    card: true,
    data_item: null,
    fields: [
      {
        label: "№",
        key: "id",
        thClass: "tableHeadClass",
      },
      {
        label: "reference.categoriya",
        key: "category",
        formatter: (value) => value && value.category,

        thClass: "tableHeadClass",
      },
      {
        label: "courses.type",
        key: "product",
        formatter: (value) => value.title,
        thClass: "tableHeadClass",
      },

      {
        label: "reference.name",
        key: "value",
        thClass: "tableHeadClass",
      },

      {
        label: "unit_of_measurement",
        key: "unity",
        thClass: "tableHeadClass",
      },
      {
        label: "amount",
        key: "total_count",
        thClass: "tableHeadClass",
      },
      {
        label: "master",
        key: "master",
        thClass: "tableHeadClass",
      },
      {
        label: "object",
        key: "object_title",
        thClass: "tableHeadClass",
      },
      {
        label: "actions",
        key: "actions",
        thClass: "tableHeadClass",
        tdClass: "d-flex justify-content-center",
      },
    ],
  }),
  computed: {
    ...mapGetters("materials", ["GET_MATERIALS_FOR_BUILDERS"]),
  },
  methods: {
    ...mapActions("materials", [
      "FETCH_PRODUCT_CATEGORIES",
      "FETCH_MATERIALS",
      "FETCH_MATERIAL_FOR_BUILDERS",
    ]),
    returnItems(data) {
      this.data_item = data;
      this.$nextTick(() => {
        this.$bvModal.show("return-modal");
      });
    },

    addPto(data) {
      this.item = data;

      this.$nextTick(() => {
        this.$bvModal.show("add-pto2-modal");
      });
    },
  },
};
</script>

<style>
</style>
